import { Action } from '@ngrx/store';
import { EmployeeModel } from '../../models/EmployeeModel';
import * as fromDataServices from '../../data-services';
export enum ActionTypes {
    ValidateTokens = '[quickbooks] ValidateTokens',
    HasValidTokens = '[Quickbooks] HasValidTokens',
    GetAuthUrl = '[Quickbooks] GetAuthUrl',
    SetAuthUrl = '[Quickbooks] SetAuthUrl',
    GetEmployeesWithHours = '[Quickbooks] GetEmployeesWithHours',
    SetEmployeesWithHours = '[Quickbooks] SetEmployeesWithHours',
    GetContractorsWithHours = '[Quickbooks] GetContractorsWithHours',
    SetContractorsWithHours = '[Quickbooks] SetContractorsWithHours',
    SendHours = '[Quickbooks] SendHours',
    SendHoursProgress = '[Quickbooks] SendHoursProgress',
    SendHoursSuccess = '[Quickbooks] SendHoursSuccess',
    SendHoursFailure = '[Quickbooks] SendHoursFailure',
    SendBills = '[Quickbooks] SendBills',
    SendBillsSuccess = '[Quickbooks] SendBillsSuccess',
    SendJournalEntries = '[Quickbooks] SendJournalEntries',
    SendJournalEntriesSuccess = '[Quickbooks] SendJournalEntriesSuccess',
    RevokeAccess = '[Quickbooks] RevokeAccess',
    GetMinApprovedTimeNotSent = '[Quickbooks] GetMinApprovedTimeNotSent',
    SetMinApprovedTimeNotSent = '[Quickbooks] SetMinApprovedTimeNotSent',
    GetMaxApprovedTimeNotSent = '[Quickbooks] GetMaxApprovedTimeNotSent',
    SetMaxApprovedTimeNotSent = '[Quickbooks] SetMaxApprovedTimeNotSent',
    GetEmployeesWithPurchases = '[Quickbooks] GetEmployeesWithPurchases',
    SetEmployeesWithPurchases = '[Quickbooks] SetEmployeesWithPurchases',
    SendPurchases = '[Quickbooks] SendPurchases',
    SendPurchasesSuccess = '[Quickbooks] SendPurchasesSuccess',
    SendInvoices = '[Quickbooks] SendInvoices',
    SendInvoicesSuccess = '[Quickbooks] SendInvoicesSuccess'
}
export class HasValidTokens implements Action {
    constructor(public payload: boolean) {}
    readonly type = ActionTypes.HasValidTokens;
}
export class ValidateTokens implements Action {
    readonly type = ActionTypes.ValidateTokens;
}
export class GetAuthUrl implements Action {
    readonly type = ActionTypes.GetAuthUrl;
}
export class SetAuthUrl implements Action {
    constructor(public payload: string) {}
    readonly type = ActionTypes.SetAuthUrl;
}
export class GetEmployeesWithHours implements Action {
    constructor(
        public payload: {
            StartDate: Date;
            EndDate: Date;
            Resend: boolean;
        }
    ) {}
    readonly type = ActionTypes.GetEmployeesWithHours;
}
export class SetEmployeesWithHours implements Action {
    constructor(public payload: EmployeeModel[]) {}
    readonly type = ActionTypes.SetEmployeesWithHours;
}
export class GetContractorsWithHours implements Action {
    constructor(
        public payload: {
            StartDate: Date;
            EndDate: Date;
            Resend: boolean;
        }
    ) {}
    readonly type = ActionTypes.GetContractorsWithHours;
}
export class SetContractorsWithHours implements Action {
    constructor(public payload: EmployeeModel[]) {}
    readonly type = ActionTypes.SetContractorsWithHours;
}
export class SendHours implements Action {
    constructor(
        public payload: {
            EmployeeListIDs: string[];
            startDate: Date;
            endDate: Date;
            resend: boolean;
        }
    ) {}
    readonly type = ActionTypes.SendHours;
}
export class SendHoursProgress implements Action {
    constructor(public payload: { current: number; total: number }) {}
    readonly type = ActionTypes.SendHoursProgress;
}
export class SendHoursSuccess implements Action {
    readonly type = ActionTypes.SendHoursSuccess;
}
export class SendHoursFailure implements Action {
    readonly type = ActionTypes.SendHoursFailure;
}
export class SendBills implements Action {
    constructor(
        public payload: {
            EmployeeListID: string;
            startDate: Date;
            endDate: Date;
            resend: boolean;
        }
    ) {}
    readonly type = ActionTypes.SendBills;
}
export class SendBillsSuccess implements Action {
    readonly type = ActionTypes.SendBillsSuccess;
}
export class SendJournalEntries implements Action {
    constructor(
        public payload: {
            EndDate: Date;
            ReversalDate: Date;
            JournalType: string;
        }
    ) {}
    readonly type = ActionTypes.SendJournalEntries;
}
export class SendJournalEntriesSuccess implements Action {
    readonly type = ActionTypes.SendJournalEntriesSuccess;
}
export class RevokeAccess implements Action {
    readonly type = ActionTypes.RevokeAccess;
}
export class GetMinApprovedTimeNotSent implements Action {
    readonly type = ActionTypes.GetMinApprovedTimeNotSent;
}
export class SetMinApprovedTimeNotSent implements Action {
    constructor(public payload: Date) {}
    readonly type = ActionTypes.SetMinApprovedTimeNotSent;
}
export class GetMaxApprovedTimeNotSent implements Action {
    readonly type = ActionTypes.GetMaxApprovedTimeNotSent;
}
export class SetMaxApprovedTimeNotSent implements Action {
    constructor(public payload: Date) {}
    readonly type = ActionTypes.SetMaxApprovedTimeNotSent;
}
export class GetEmployeesWithPurchases implements Action {
    constructor(
        public payload: { StartDate: Date; EndDate: Date; Resend: boolean }
    ) {}
    readonly type = ActionTypes.GetEmployeesWithPurchases;
}
export class SetEmployeesWithPurchases implements Action {
    constructor(public payload: EmployeeModel[]) {}
    readonly type = ActionTypes.SetEmployeesWithPurchases;
}
export class SendPurchases implements Action {
    constructor(
        public payload: {
            EmployeeListID: string;
            startDate: Date;
            endDate: Date;
            Resend: boolean;
            sendImages: boolean;
        }
    ) {}
    readonly type = ActionTypes.SendPurchases;
}
export class SendPurchasesSuccess implements Action {
    constructor(
        public payload: {
            startDate: Date;
            endDate: Date;
            Resend: boolean;
        }
    ) {}

    readonly type = ActionTypes.SendPurchasesSuccess;
}
export class SendInvoices implements Action {
    constructor(public payload: fromDataServices.Invoice.InvoiceModel[]) {}
    readonly type = ActionTypes.SendInvoices;
}
export class SendInvoicesSuccess implements Action {
    constructor(public payload: fromDataServices.Invoice.InvoiceModel[]) {}
    readonly type = ActionTypes.SendInvoicesSuccess;
}
export type ActionsUnion =
    | HasValidTokens
    | ValidateTokens
    | GetAuthUrl
    | SetAuthUrl
    | GetEmployeesWithHours
    | SetEmployeesWithHours
    | GetContractorsWithHours
    | SetContractorsWithHours
    | SendHours
    | SendHoursProgress
    | SendHoursFailure
    | SendBills
    | SendJournalEntries
    | RevokeAccess
    | GetEmployeesWithPurchases
    | SetEmployeesWithPurchases
    | SendPurchases
    | SendInvoices
    | SendInvoicesSuccess
    | SendHoursSuccess
    | SendBillsSuccess
    | SendJournalEntriesSuccess
    | GetMinApprovedTimeNotSent
    | GetMaxApprovedTimeNotSent
    | SetMinApprovedTimeNotSent
    | SetMaxApprovedTimeNotSent;
